module.exports = __webpack_public_path__ + "static/media/Klee.16cff1c0.png";